'use strict'

// simple mutable assign
function assign () {
  const args = [].slice.call(arguments).filter(i => i)
  const dest = args.shift()
  args.forEach(src => {
    Object.keys(src).forEach(key => {
      dest[key] = src[key]
    })
  })

  return dest
}

module.exports = assign



//////////////////
// WEBPACK FOOTER
// ./~/fs-promise/~/fs-extra/lib/util/assign.js
// module id = 1315
// module chunks = 0 1 2